import styled from 'styled-components'

export const BoxStyle = styled.div`
  background-color: ${({ color }) => color};
  border-radius: 10px;
  box-shadow: 0 10px 20px 0 rgba(102, 102, 102, 0.05);
`
